export default __webpack_public_path__ + "media/src/assets/images/MapPinCrossdock-2c7899ebeeac74f0f04b3366bdc88321.svg";